module.exports = __webpack_public_path__ + "img/11passenger_driving.cc368a0e.svg";